import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { type TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';

/**
 * For a given tableView, it returns a boolean specifying whether the
 * AutomaticRepliesBanner should be shown or not
 * @param tableView
 */
const shouldShowAutomaticRepliesBanner = (tableView: TableView): boolean =>
    // Never show automatic replies banner if current tableView is of Search
    // Or if it's not to be shown based on the configuration
    !!(tableView?.tableQuery?.type === 0) && getListViewStore().shouldShowAutomaticRepliesBanner;

export default shouldShowAutomaticRepliesBanner;
